import React from 'react';

/**
 * Toolbar — a horizontal action bar with start / end slots, for use above
 * tables and content areas (bulk actions, view switches, filters, buttons).
 *
 * Props:
 *   start: ReactNode    — left-aligned content
 *   end: ReactNode      — right-aligned content
 *   children: alternative to `start`
 */
const Toolbar = ({ start, end, className = '', children }) => (
  <div className={`ps-toolbar ${className}`.trim()} role="toolbar">
    <div className="ps-toolbar__start">{start ?? children}</div>
    {end && <div className="ps-toolbar__end">{end}</div>}
  </div>
);

export default Toolbar;
